import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { ScrollArea } from "@coveord/plasma-mantine";
import { forwardRef } from "react";
export var FacetScrollArea = /*#__PURE__*/ forwardRef(function(_param, ref) /*#__PURE__*/ {
    var style = _param.style, others = _object_without_properties(_param, [
        "style"
    ]);
    return _jsx(ScrollArea, _object_spread_props(_object_spread({}, others), {
        style: _object_spread({
            width: "100%"
        }, style),
        viewportRef: ref,
        children: others.children
    }));
});

//# sourceMappingURL=FacetScrollArea.js.map